import {LangUtil} from '../lang-util'

export const permissionEn = {
  regLinkCreate: 'Create a company link',
  regLink: 'Company address',
  regLinkEmpty: 'not set',
  regLinkHint:
    'If the domain is set up then people can register in this ' +
    'company. After registration no projects will be available.',
  regLinkIncorrect:
    'Subdomain should contain only alphanumeric sumbols and hyphen, ' +
    'start with letter and be longer than 2 symbols',
  regLinkTaken: 'This name is already reserved',
  companyNotFound:
    'Company not found, please, check that the link you’ve entered is correct',
  loggedInAs: 'You logged in as',
  enterCompany: 'Enter company',
  enterOther: 'Enter with different account',
  register: 'Register with another email',
  regLinkSubject: 'Registration in YouGile',
  regLinkMail1: (companyName: string) =>
    LangUtil.stripMargin(`
    You requested registration in company “${companyName}”, to proceed
    with registration follow this
  `),
  regLinkMailAdminSubject: 'New registration request',
  regLinkMailAdmin: (companyName: string) =>
    LangUtil.stripMargin(`
    The company “${companyName}” has new requests to confirm registration.
    To view them follow this
  `),
  regLinkMailUserSubject: 'Registration with YouGile approved',
  regLinkMailUser: () =>
    LangUtil.stripMargin(`
    Your registration request has been approved
    To get started with YouGile follow this
`),
  regLinkMail2: 'link',
  regLinkSentEmail:
    'Done. Please check email that was sent to you to start using YouGile.',
  regLinkRegistrationFinished:
    'Your registration request has been sent to the company administrator. After confirmation you will be given access.',
  regLinkPageHint1: 'On this page you can enter company',
  regLinkPageHint2: 'Choose from options below',
  regLinkSingIn: 'Already have account. Log in',
  regLinkSingUp: 'Register new account and enter the company',
  regLinkCopied: 'Copied',
  regProjectLinkCopied: 'Project link copied',
  regLinkCopy: 'Copy',
  regLinkCopy2: 'Copy to clipboard',
  regLinkCopyHint: 'Copy link',
  regLinkInputHint: 'Input subdomain',
  regLinkDelete: 'Delete address',
  regLinkSetup: 'Setup',
  regLinkChange: 'Change',
  role: 'role',
  noEditObject:
    'You are not allowed to edit access settings for this ' +
    'object. Only administrators and users with full access to projects can ' +
    'edit object permissions',
  noAccess: 'You have no read access to this object',
  adminRole: 'Manager',
  adminRoleDescription:
    'Full access. Can edit everything inside project and manage ' +
    'user permissions in the project',
  workerRole: 'Worker',
  workerRoleDescription:
    'Access to tasks. Can edit project content but cannot change ' +
    'its structure (boards, columns)',
  observerRole: 'Observer',
  observerRoleDescription:
    'Can comment. Can see everything and post messages in chat',
  headerUser: 'User',
  headerEmail: 'E-mail address',
  headerRole: 'Role in project',
  headerProject: 'Project name',
  removeUserHint: 'Remove this user from company',
  usersNotInProject: 'Users not in project',
  isAdmin: 'Company admin',
  addAdmin: 'Make admin',
  removeAdmin: 'Remove admin rights',
  deleteUser: 'Delete from company',
  participateProjects: 'Participate in projects',
  addUsersToProject: 'Add users to project',
  userCantSeeTask:
    'This user have no access to this task, ' +
    'so you can’t pin this user to the task',
  participateDepartments: 'Participate in departments',
  headerDep: 'Department name',
  headerDepRole: 'Role in department',
  depManager: 'Manager',
  depMember: 'Member',
  depEditWarn: 'Only admins can edit departments',
  userName: 'User name',
  position: 'Position',
  shortName: 'Name',
  department: 'Department',
  reason: 'Reason',
  yourPrivateTask: 'Your private task',
  adminReason: 'Administrator',
  assignedReason: 'Assignee',
  subscribedReason: 'Subscribed to chat',
  managerReason: 'Manager of department with assigned user',
  upperManagerReason:
    'Manager of upper department for one of the assigned users',
  inProjectReason: 'Added to task’s project',
  addFromEmailList: 'Add list of e-mails',
  emailListHint: 'Add e-mails separated by newline, comma, semicolon or tab',
  emailListPlaceholder: 'List of e-mails',
  emailListResult: (n: number) =>
    `Choosen ${n} e-mails. Press button bellow to invite them`,
  emailListEmpty: 'No valid e-mails found in your input',
  emailInviteFail: 'Failed to send invitation to e-mails',
  revert: 'Revert'
}

export const permissionRu: typeof permissionEn = {
  regLinkCreate: 'Создать ссылку на компанию',
  regLink: 'Ссылка для приглашения в компанию',
  regLinkEmpty: 'не настроено',
  regLinkHint:
    'Пользователи могут сами ' +
    'зарегистрироваться по этой ссылке. После регистрации ' +
    'им не будут доступны проекты, нужно будет отдельно распределить ' +
    'их в проекты',
  regLinkIncorrect:
    'Поддомен должен состоять из латинских букв, цифр и дефиса, ' +
    'начинаться с буквы и быть длиннее 2-х символов',
  regLinkTaken: 'Это имя уже занято',
  companyNotFound:
    'Компания не найдена, проверьте правильность ссылки, по которой вы перешли',
  loggedInAs: 'Вы залогинены как',
  enterCompany: 'Войти в компанию',
  enterOther: 'Войти под другим аккаунтом',
  register: 'Зарегистрироваться под другим email-ом',
  regLinkSubject: 'Регистрация в YouGile',
  regLinkMail1: (companyName: string) =>
    LangUtil.stripMargin(`
    Вы запросили доступ к компании «${companyName}» в системе YouGile,
    чтобы продолжить регистрацию пройдите по
  `),
  regLinkMailAdminSubject: 'Новый запрос на регистрацию',
  regLinkMailAdmin: (companyName: string) =>
    LangUtil.stripMargin(`
    В компании «${companyName}» есть новые запросы на подтверждение регистрации.
    Чтобы ознакомиться с ними перейдите по
  `),
  regLinkMailUserSubject: 'Регистрация в YouGile одобрена',
  regLinkMailUser: () =>
    LangUtil.stripMargin(`
    Ваш запрос на регистрацию одобрен.
    Чтобы начать работу в YouGile пройдите по
`),
  regLinkMail2: 'этой ссылке',
  regLinkSentEmail:
    'Готово. Вам на почту отправлено письмо с подтверждением регистрации.',
  regLinkRegistrationFinished:
    'Ваш запрос на регистрацию направлен администратору компании. После подтверждения вам откроется доступ.',
  regLinkPageHint1: 'На этой странице вы можете войти в компанию',
  regLinkPageHint2: 'Выберите одну из опций ниже',
  regLinkSingIn: 'Уже есть аккаунт. Войти',
  regLinkSingUp: 'Зарегистрировать новый аккаунт и войти',
  regLinkCopied: 'Скопировано',
  regProjectLinkCopied: 'Скопирована ссылка на проект',
  regLinkCopy: 'Копировать',
  regLinkCopy2: 'Скопировать в буфер',
  regLinkCopyHint: 'Скопировать ссылку',
  regLinkInputHint: 'Введите поддомен',
  regLinkDelete: 'Удалить адрес',
  regLinkSetup: 'Настроить',
  regLinkChange: 'Изменить',

  role: 'роль',
  noEditObject:
    'Вы не можете редактировать права к этому объекту. ' +
    'Для возможности редактирования вы должны быть добавлены в проект с ' +
    'полными правами или быть администратором компании',
  noAccess: 'Объект не может быть отображён, так как у вас нет доступа к нему',
  adminRole: 'Управляющий',
  adminRoleDescription:
    'Полный доступ. Может менять структуру и пользователей проекта. ' +
    'Настраивать права, создавать доски и колонки.',
  workerRole: 'Сотрудник',
  workerRoleDescription:
    'Доступ к задачам. Может работать с задачами, но не менять структуру ' +
    'проекта (доски, колонки).',
  observerRole: 'Наблюдатель',
  observerRoleDescription:
    'Доступ к чатам. Может комментировать в чате, ничего не меняя в задачах.',
  headerUser: 'Сотрудник',
  headerEmail: 'E-mail адрес',
  headerRole: 'Роль в проекте',
  headerProject: 'Название проекта',
  removeUserHint: 'Удалить этого сотрудника из компании',
  usersNotInProject: 'Сотрудники, не добавленные в этот проект',
  isAdmin: 'Администратор компании',
  addAdmin: 'Назначить администратором',
  removeAdmin: 'Убрать из админов',
  deleteUser: 'Удалить сотрудника из компании',
  participateProjects: 'Участник проектов',
  addUsersToProject: 'Добавить сотрудников в проект',
  userCantSeeTask:
    'У этого сотрудника нет доступа к этой задаче, ' +
    'поэтому его нельзя назначать исполнителем',
  participateDepartments: 'Состоит в отделах',
  headerDep: 'Название отдела',
  headerDepRole: 'Роль в отделе',
  depManager: 'Руководитель',
  depMember: 'Сотрудник',
  depEditWarn: 'Только администраторы могут менять отделы',
  userName: 'Имя пользователя',
  position: 'Должность',
  shortName: 'Имя',
  department: 'Отдел',
  reason: 'Причина',
  yourPrivateTask: 'Ваша приватная задача',
  adminReason: 'Администратор',
  assignedReason: 'Исполнитель задачи',
  subscribedReason: 'Подписан на чат задачи',
  managerReason: 'Руководитель отдела, где исполнитель является сотрудником',
  upperManagerReason: 'Руководитель вышестоящего отдела исполнителя задачи',
  inProjectReason: 'Добавлен в проект, где находится задача',
  addFromEmailList: 'Добавить список e-mail-ов',
  emailListHint:
    'Добавьте список e-mail-ов, разделённый новой строкой, запятой, точкой с запятой или Tab',
  emailListPlaceholder: 'Список e-mail-ов',
  emailListResult: (n: number) =>
    `Выбрано e-mail-ов: ${n}. Нажмите кнопку внизу, чтобы пригласить их`,
  emailListEmpty: 'В поле не найдено ни одного e-mail-а правильного формата',
  emailInviteFail: 'Не удалось отправить приглашение на почту',
  revert: 'Сбросить'
}
